export const BRAND_ACTION_DICTIONARY = {
  moveToProcessed: 'MOVE_TO_PROCESSED',
  sendInvitation: 'SEND_INVITATION',
  archiveUnarchive: 'ARCHIVE_UNARCHIVE',
}
